"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Markdown = exports.MarkDownNotes = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_markdown_1 = __importDefault(require("react-markdown"));
const styles_1 = require("../../styles");
const typography_1 = require("../typography");
const buttons_1 = require("../buttons");
const layout_1 = require("../layout");
const remark_gfm_1 = __importDefault(require("remark-gfm"));
const MAPPED_COMPONENTS = {
    div: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownDiv, Object.assign({}, props));
    },
    h1: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownH1, Object.assign({}, props));
    },
    h2: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownH2, Object.assign({}, props));
    },
    h3: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownH3, Object.assign({}, props));
    },
    h4: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownH4, Object.assign({}, props));
    },
    h5: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownH5, Object.assign({}, props));
    },
    h6: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownH6, Object.assign({}, props));
    },
    ul: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownUL, Object.assign({}, props));
    },
    ol: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownOL, Object.assign({}, props));
    },
    p: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownP, Object.assign({}, props));
    },
    span: () => (0, jsx_runtime_1.jsx)(ReactMarkdownSpan, {}),
    strong: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownStrong, Object.assign({}, props));
    },
    a: (_a) => {
        var props = __rest(_a, []);
        const linkWithBlankTarget = Object.assign(Object.assign({}, props), { target: '_blank' });
        return (0, jsx_runtime_1.jsx)(ReactMarkdownA, Object.assign({}, linkWithBlankTarget));
    },
    em: (_a) => {
        var props = __rest(_a, []);
        return (0, jsx_runtime_1.jsx)(ReactMarkdownEM, Object.assign({}, props));
    },
};
const MarkDownNotes = ({ text, onEdit, showTitle, readOnly = false, editButtonStyles = {}, }) => {
    const theme = (0, styles_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ "data-testid": "markdown-call-notes-view" }, { children: [(0, jsx_runtime_1.jsxs)(Header, { children: [showTitle && ((0, jsx_runtime_1.jsx)(typography_1.Subheader, Object.assign({ size: "mediumLarge", "data-testid": "call-notes-heading" }, { children: "Call Notes" }))), !readOnly && ((0, jsx_runtime_1.jsx)(buttons_1.IconButton, { iconName: "EditIcon", name: "editNotes", label: "Edit Notes", onClick: onEdit, style: Object.assign({ marginLeft: 'auto', color: theme.colors.grey50 }, editButtonStyles), "data-testid": "edit-notes-icon" }))] }), (0, jsx_runtime_1.jsx)(exports.Markdown, { text: text })] })));
};
exports.MarkDownNotes = MarkDownNotes;
const Markdown = ({ text }) => {
    return ((0, jsx_runtime_1.jsx)(react_markdown_1.default, Object.assign({ components: MAPPED_COMPONENTS, remarkPlugins: [remark_gfm_1.default] }, { children: text })));
};
exports.Markdown = Markdown;
const Header = (0, styles_1.styled)(layout_1.Row)({
    padding: '3px',
    textAlign: 'left',
});
const ReactMarkdownDiv = styles_1.styled.div({
    textAlign: 'left',
});
const ReactMarkdownH1 = styles_1.styled.h1(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '22px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownH2 = styles_1.styled.h2(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '20px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'anywhere',
}));
const ReactMarkdownH3 = styles_1.styled.h3(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '18px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownH4 = styles_1.styled.h4(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '16px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownH5 = styles_1.styled.h5(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '14px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownH6 = styles_1.styled.h6(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: '13px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownUL = (0, styles_1.styled)('ul')({
    marginTop: '1em',
    marginBottom: '1em',
    marginLeft: '2em',
    listStyle: 'circle outside none',
});
const ReactMarkdownOL = (0, styles_1.styled)('ol')({
    marginTop: '1em',
    marginBottom: '1em',
    marginLeft: '2em',
    listStyleType: 'decimal',
});
const ReactMarkdownSpan = styles_1.styled.span(({ theme }) => ({
    color: theme.colors.grey90,
    fontFamily: 'ASAP',
    fontSize: '16px',
    lineHeight: '1.5',
}));
const ReactMarkdownP = styles_1.styled.p(({ theme }) => ({
    display: 'block',
    color: theme.colors.grey90,
    fontFamily: 'ASAP',
    fontSize: '16px',
    lineHeight: '1.5',
    overflowWrap: 'anywhere',
}));
const ReactMarkdownStrong = styles_1.styled.strong(({ theme }) => ({
    fontWeight: 600,
    fontFamily: 'ASAP',
    fontSize: '16px',
    color: theme.colors.grey90,
}));
const ReactMarkdownA = styles_1.styled.a(({ theme }) => ({
    color: theme.colors.blue50,
    fontFamily: 'Poppins',
    fontSize: '16px',
    textDecoration: 'none',
    fontWeight: 600,
    overflowWrap: 'break-word',
    ':hover': {
        color: theme.colors.blue40,
    },
}));
const ReactMarkdownEM = styles_1.styled.em(({ theme }) => ({
    fontFamily: 'ASAP',
    fontStyle: 'italic',
    color: theme.colors.grey90,
}));
//# sourceMappingURL=markdown_notes.js.map